<template>
  <CrudList
    title="Usuarios"
    storeName="Users"
    labelAddNew="Agregar"
    descriptionDeleted="Se eliminarán también los spots y autos del usuario. Está seguro que quiere continuar?"
    labelModalConfirm="Si"
    labelModalCancel="No"
    slot-scope="{ item }"
    :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '#'
      },
      {
        text: 'Usuarios',
        disabled: true,
        href: '/admin/users_scroll'
      }
    ]"
    sortable
    canSearch
    :canExport="true"
    :filters="options"
  >
  <template v-slot:head_item>
    <v-select
      v-model="options.type"
      label="Segmento"
      :items="types"
      class="select-search max-w-270"
      solo
      elevation="0"
      dense
      hide-details
      append-icon="$caretUp"
          
    >
      <template slot="no-data">
        <v-alert :value="true"> There is no info to show </v-alert>
      </template>
    </v-select>
  </template>
    <template v-slot:profile_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.profile_picture">
            <img :src="item.profile_picture" alt="" />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>

    <template v-slot:rent_orders="{ item }">
      
      <v-btn
        elevation="0"
        class="my-1 btn-black"
        :color="(item.color_rend_spot && item.rent_orders.length>0)?item.color_rend_spot: 'primary'"
        @click="$router.push('/admin/users/' + item.id + '/rent_orders')"
      >
        Estadias
      </v-btn>
    </template>

    <template v-slot:spots="{ item }">
      <v-btn
        elevation="0"
        class="my-1 btn-black"
        :color="(item.color_spot && item.spots.length>0)?item.color_spot: 'primary'"
        @click="$router.push('/admin/users/' + item.id + '/spots')"
      >
        Spots
      </v-btn>
    </template>

    <template v-slot:cars="{ item }">
      <v-btn
        elevation="0"
        class="my-1 btn-black"
        :color="(item.color_car && item.cars.length>0)?item.color_car==='grey'?'green':item.color_car:'primary'"
        @click="$router.push('/admin/users/' + item.id + '/cars')"
      >
        Autos
      </v-btn>
    </template>
    <template v-slot:created_at="{ item }">
      {{ formatDateTimeUtc3(item.created_at) }}
    </template>
  </CrudList>
</template>

<script>
import { mapState } from "vuex";
import CrudList from "@/components/Crud/CrudList";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudList },
  computed: {
    ...mapState({
      color_spots: (state) => state.Spots.colors,
      color_cars: (state) => state.Cars.colors,
    }),
  },
  options: {
      async handler(val, old_val) {
        this.options = val;
      },
      deep: true,
    },
  data(){
    return {
      options:{
        type:''
      },
      types: [
        {
          text: "Spot no verificado",
          value: "spot_no_verf",
        },
        {
          text: "Spot verificado sin constancia de domicilio",
          value: "spot_verf_sin_const",
        },
        {
          text: "Spot verificado con constancia de domicilio",
          value: "spot_verf_con_const",
        },
        {
          text: "Con estadias",
          value: "con_estadias",
        },
        {
          text: "Sin estadias",
          value: "sin_estadias",
        },
        {
          text: "Con autos",
          value: "user_with_car_and_spot",
        },
        {
          text: "Sin autos",
          value: "user_without_car_and_spot",
        },
      ],
      
    }
  }
};
</script>
